/**
 * Featured collection grid. Carousel below 960px (unless mobile layout is grid), CSS grid above.
 * Loaded from sections/featured-collection-grid.liquid as type="module".
 */

const SELECTOR = '[data-section-type="featured-collection-grid"]'
const MQ = matchMedia('(max-width: 959px)')

function slidesPerView(container) {
  const perView = Number(container.dataset.productsPerView) || 4
  const mobile = (Number(container.dataset.mobileProductsPerView) || 2) * 1.05
  if (window.innerWidth >= 720) return perView === 5 ? 4 : perView
  return mobile
}

function gap() {
  return window.innerWidth >= 720 ? 16 : 12
}

function trackOf(container) {
  return container.querySelector('.swiper-wrapper')
}

function apply(container) {
  const viewport = container.querySelector('.carousel')
  const track = trackOf(container)
  if (!viewport || !track) return

  const count = slidesPerView(container)
  const space = gap()
  const width = `calc((100% - ${(count - 1) * space}px) / ${count})`

  track.classList.add('carousel__track--native')
  track.style.gap = `${space}px`

  for (const slide of track.children) {
    slide.style.width = width
    slide.style.flexShrink = '0'
    slide.style.scrollSnapAlign = 'start'
  }

  viewport.classList.toggle('has-overflow', track.scrollWidth > track.clientWidth + 1)
}

function teardown(container) {
  const viewport = container.querySelector('.carousel')
  const track = trackOf(container)
  if (!track) return

  track.classList.remove('carousel__track--native')
  track.style.removeProperty('gap')
  viewport?.classList.remove('has-overflow')

  for (const slide of track.children) {
    slide.style.removeProperty('width')
    slide.style.removeProperty('flex-shrink')
    slide.style.removeProperty('scroll-snap-align')
  }
}

function sync(container) {
  // Grid mobile layout is handled by Tailwind classes in the section
  if (MQ.matches && container.dataset.mobileLayout !== 'grid') apply(container)
  else teardown(container)
}

function init(container) {
  if (container.dataset.fcInit) return
  container.dataset.fcInit = 'true'

  document.dispatchEvent(new CustomEvent('product-item:reinit', { detail: { root: container } }))

  trackOf(container)?.addEventListener('focusin', (event) => {
    if (!document.body.classList.contains('user-is-tabbing')) return
    event.target.closest('.swiper-slide')?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    })
  })

  sync(container)
  window.addEventListener('resize', () => sync(container))
}

function initAll(root = document) {
  root.querySelectorAll(SELECTOR).forEach(init)
}

initAll()

document.addEventListener('shopify:section:load', (event) => {
  initAll(event.target)
})
